import BudgetPreferencesView from "./BudgetPreferencesView"
export default BudgetPreferencesView
